export default "__VITE_ASSET__CpLfH7lf__"